<template>
    <div class="paging_wrap" id="list_paginate">
        <ul>
            <!-- 처음 버튼 -->
            <li class="first_btn arrow_btn" :class="{ on: currentPage > 1 }" @click="currentPage > 1 && fnPaging(1)">
                <span></span>
            </li>
            <!-- 이전 버튼 -->
            <li class="prev_btn arrow_btn" :class="{ on: currentPage > 1 }" @click="currentPage > 1 && fnPaging(currentPage - 1)">
                <span></span>
            </li>

            <!-- 페이지 번호 -->
            <li
                v-for="page in visiblePages"
                :key="page"
                @click="fnPaging(page)"
                class="pg_btn"
                :class="{ pg_current_btn: page === currentPage }"
            >
                <span>{{ page }}</span>
            </li>

            <!-- 다음 버튼 -->
            <li class="next_btn arrow_btn" :class="{ on: currentPage < paging }" @click="currentPage < paging && fnPaging(currentPage + 1)">
                <span></span>
            </li>

            <!-- 마지막 버튼 -->
            <li class="last_btn arrow_btn" :class="{ on: currentPage < paging }" @click="currentPage < paging && fnPaging(paging)">
                <span></span>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
    import { computed } from "vue";

    export default {
        props: {
            currentPage: { type: Number, required: true },
            totalLength: { type: Number, required: true },
            perPage: { type: Number, required: true },
        },
        emits: ["onPaging"],

        setup(props: any, { emit }: any) {
            const paging = computed(() => Math.max(1, Math.ceil(props.totalLength / props.perPage)));
            const visiblePages = computed(() => {
                const pages = [];
                if (props.currentPage <= 3) {
                    for (let i = 1; i <= Math.min(5, paging.value); i++) {
                        pages.push(i);
                    }
                } else if (props.currentPage >= paging.value - 2) {
                    for (let i = Math.max(1, paging.value - 4); i <= paging.value; i++) {
                        pages.push(i);
                    }
                } else {
                    for (let i = props.currentPage - 2; i <= props.currentPage + 2; i++) {
                        pages.push(i);
                    }
                }
                return pages;
            });

            const fnPaging = (page: number) => {
                emit("onPaging", page);
            };

            return {
                paging,
                visiblePages,
                fnPaging,
            };
        },
    };
</script>

<style scoped>
    .paging_wrap .pg_current_btn span {
        width: auto;
        min-width: 32px;
    }

    #board_layer .paging_wrap .first_btn.on span {
        cursor: pointer;
        background-image: url("@/assets/board/first_btn_on.png");
    }
    #board_layer .paging_wrap .last_btn.on span {
        cursor: pointer;
        background-image: url("@/assets/board/last_btn_on.png");
    }
    #board_layer .paging_wrap .first_btn span {
        background-image: url("@/assets/board/first_btn_off.png");
    }

    #board_layer .paging_wrap .last_btn span {
        background-image: url("@/assets/board/last_btn_off.png");
    }
</style>
